import { v4 as uuidv4 } from 'uuid'
import { LDFlagSet } from 'launchdarkly-react-client-sdk'
import { DataField, type WeekModifier, type DashboardCardDef } from './types'
import { filterCardsByFeatureSet } from './utils/filterCardsByFeatureSet'

const PSI_PLUS = 'releasePsiPlus'

export const customSearchCards: DashboardCardDef[] = [
    {
        id: '',
        type: 'SalesThisWeek',
        width: 2,
        height: 1,
        config: {
            weekModifier: 0 as WeekModifier,
        },
        readOnly: true,
    },
    {
        id: '',
        type: 'UnifiedAPIEligiblePSI',
        width: 1,
        height: 1,
        config: {
            weekModifier: 0 as WeekModifier,
        },
        readOnly: true,
        featureFlags: { include: [PSI_PLUS] },
    },
    {
        id: '',
        type: 'SalesLastWeek',
        width: 2,
        height: 1,
        config: {
            weekModifier: 1 as WeekModifier,
        },
        readOnly: true,
    },
    {
        id: '',
        type: 'SalesNextWeek',
        width: 2,
        height: 1,
        config: {
            weekModifier: -1 as WeekModifier,
        },
        readOnly: true,
    },
    {
        id: '',
        type: 'RegisteredNextWeek',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'NewCustomersThisWeek',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'WatchedVehicles',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'BiddersThisWeek',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'VehiclesCheckedInCount',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'NeedPhotos',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'NeedPhotosPreSale',
        width: 1,
        height: 1,
        config: {
            label: 'Need Photos (Pre-Sale)',
            title: 'Vehicles',
            linkurl: '/searchdetails/customcard/vehicle-presale',
            sublabel: 'from the last 5 days',
            linklabel: 'VIEW VEHICLES (PRESALE)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:available checkindate:5 photos<5',
                searchDetailView: 'vehicles-presale',
                searchDetailTitle: 'Vehicles Need Photos (Pre-Sale)',
            },
        },
    },
    {
        id: '',
        type: 'ConsignedVehicles',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'NeedCRPreSale',
        width: 1,
        height: 1,
        config: {
            label: 'Need CR (Pre-Sale)',
            title: 'Vehicles',
            linkurl: '/searchdetails/customcard/vehicle-presale',
            sublabel: 'from the last 5 days',
            linklabel: 'VIEW VEHICLES (PRESALE)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:available checkindate:5 cr:no',
                searchDetailView: 'vehicles-presale',
                searchDetailTitle: 'Vehicles Need CR (Pre-Sale)',
            },
        },
    },
    {
        id: '',
        type: 'CompletedVehicles',
        width: 1,
        height: 1,
        config: {
            label: 'Sold / Exited / Redeemed / Returned',
            title: 'Sold / Exited / Redeemed / Returned',
            linkurl: '/searchdetails/customcard/vehicle-ci',
            sublabel: '',
            linklabel: 'VIEW VEHICLES',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:sold,exited,redeemed,returned',
                searchDetailView: 'vehicles',
                searchDetailTitle: 'Sold / Exited / Redeemed / Returned',
            },
        },
        readOnly: true,
    },
    {
        id: '',
        type: 'PipelineVehicleListings',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'VehiclesWithDocuments',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'VDPViews',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'MyContactLogFollowups',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'SearchCard',
        width: 1,
        height: 1,
        config: {
            title: 'Vehicles (Sold last 90)',
            label: 'Units Sold',
            sublabel: 'in the last 90 days',
            linklabel: 'VIEW VEHICLES',
            linkurl: '/searchdetails/vehicle-ci',
            search: {
                searchString: 'saledate:90',
                primary: {
                    dataField: DataField.SOLD,
                    rightLabel: '',
                },
                lowerLeft: {
                    dataField: DataField.CONVERSION,
                    leftLabel: 'Conversion: ',
                },
                lowerRight: {
                    dataField: DataField.AVG_SALE_AMOUNT,
                    leftLabel: 'Avg Sales: ',
                },
                searchDetailView: 'vehicles',
            },
        },
    },
    {
        id: '',
        type: 'ContactLogSearchCard',
        width: 1,
        height: 1,
        config: {
            title: 'Created (Last 90 Days)',
            label: 'Total',
            sublabel: 'Contact Log search',
            linklabel: 'VIEW CONTACTS',
            linkurl: '/searchdetails/customcard/contact-log',
            contactLogSearch: {
                searchString: 'contacted:90',
                primary: {
                    dataField: DataField.TOTAL,
                    rightLabel: '',
                },
                searchDetailView: 'contacts',
            },
        },
    },
    {
        id: '',
        type: 'PendingOffers',
        width: 1,
        height: 1,
        config: {
            label: 'Pending Offers',
            title: 'Vehicles',
            linkurl: '/ifoffers',
            linklabel: 'View Vehicles (Offers)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:offer',
                searchDetailView: 'ifoffers',
                searchDetailTitle: 'Pending Offers',
            },
        },
    },
    {
        id: '',
        type: 'PendingArbitrations',
        width: 1,
        height: 1,
        config: {
            label: 'Pending Arbitrations',
            title: 'Vehicles',
            linkurl: '/searchdetails/customcard/vehicle-deals',
            linklabel: 'View Vehicles (Deals)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:arbitration',
                searchDetailView: 'vehicles-deals',
                searchDetailTitle: 'Pending Arbitrations',
            },
        },
    },
    {
        id: '',
        type: 'NeedsTitles',
        width: 1,
        height: 1,
        config: {
            label: 'Needs Titles',
            title: 'Vehicles',
            linkurl: '/searchdetails/customcard/vehicle-deals',
            linklabel: 'View Vehicles (Deals)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'title:no status:sold,offer,arbitration',
                searchDetailView: 'vehicles-deals',
                searchDetailTitle: 'Needs Titles',
            },
        },
    },
    {
        id: '',
        type: 'DMSVehicles',
        width: 1,
        height: 1,
        config: {
            label: 'DMS Vehicles',
            title: 'Vehicles',
            linkurl: '/searchdetails/customcard/vehicle-dealer',
            linklabel: 'View Vehicles (DMS)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'feed:DMS',
                searchDetailView: 'vehicles-dealer',
                searchDetailTitle: 'DMS Vehicles',
            },
        },
    },
    {
        id: '',
        type: 'Favorites',
        width: 1,
        height: 1,
        config: {},
        readOnly: true,
    },
    {
        id: '',
        type: 'FavoriteSellers',
        width: 1,
        height: 1,
        config: {},
    },
    {
        id: '',
        type: 'FavoriteBuyers',
        width: 1,
        height: 1,
        config: {},
    },
    // PSI Eligible original
    {
        id: '',
        type: 'EligiblePSI',
        width: 1,
        height: 1,
        locked: true,
        featureFlags: { exclude: [PSI_PLUS] },
        config: {
            label: 'Eligible PSIs',
            title: 'Vehicles',
            linkurl: '/postsaleinspections/eligible',
            linklabel: 'View Vehicles (Eligible)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:sold sd:6 psi:no',
                searchDetailView: 'postsaleinspections-eligible',
                searchDetailTitle: 'Eligible for PSI',
            },
        },
    },
    {
        id: '',
        type: 'PSIOrderedTotal',
        width: 1,
        height: 1,
        locked: true,
        featureFlags: { exclude: [PSI_PLUS] },
        config: {
            label: 'PSI Orders',
            sublabel: 'in the last 7 days',
            title: 'Vehicles',
            linkurl: '/postsaleinspections/orders',
            linklabel: 'View Vehicles (Orders)',
            search: {
                primary: { dataField: DataField.TOTAL },
                lowerLeft: {
                    dataField: DataField.COMPLETED, // TODO: new COMPLETED agg field?
                    leftLabel: 'Completed: ',
                },
                searchString: 'status:sold sd:6 psi:yes',
                searchDetailView: 'postsaleinspections-orders',
            },
        },
    },
    {
        id: '',
        type: 'PSIOrderedSpark',
        width: 1,
        height: 1,
        locked: true,
        featureFlags: { exclude: [PSI_PLUS] },
        config: {
            label: 'Spark PSI Orders',
            sublabel: 'in the last 7 days',
            title: 'Vehicles',
            linkurl: '/postsaleinspections/orders',
            linklabel: 'View Vehicles (Orders)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:sold sd:6 psi:yes psisource:spark',
                searchDetailView: 'postsaleinspections-orders',
            },
        },
    },
    {
        id: '',
        type: 'PSIOrderedAMS',
        width: 1,
        height: 1,
        locked: true,
        featureFlags: { exclude: [PSI_PLUS] },
        config: {
            label: 'AMS PSI Orders',
            sublabel: 'in the last 7 days',
            title: 'Vehicles',
            linkurl: '/postsaleinspections/orders',
            linklabel: 'View Vehicles (Orders)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:sold sd:6 psi:yes psisource:ams',
                searchDetailView: 'postsaleinspections-orders',
            },
        },
    },
    {
        id: '',
        type: 'PSIOrderedPipeLine',
        width: 1,
        height: 1,
        locked: true,
        featureFlags: { exclude: [PSI_PLUS] },
        config: {
            label: 'Pipeline PSI Orders',
            sublabel: 'in the last 7 days',
            title: 'Vehicles',
            linkurl: '/postsaleinspections/orders',
            linklabel: 'View Vehicles (Orders)',
            search: {
                primary: { dataField: DataField.TOTAL },
                searchString: 'status:sold sd:6 psi:yes psisource:pipeline',
                searchDetailView: 'postsaleinspections-orders',
            },
        },
    },
    {
        id: '',
        type: 'BetaIfs',
        width: 1,
        height: 1,
        //featureFlags: { include: [SIERRA_OFFER_CARD] },
        config: {
            label: 'Beta Pending Offers',
            title: 'Pending Offers',
            linkurl: '/odsifoffers',
            linklabel: 'View Vehicles (Beta Offers)',
            weekModifier: 0 as WeekModifier,
        },
        readOnly: true,
    },
]

export const getCustomSearchCards = (flags: LDFlagSet): DashboardCardDef[] => {
    const userDisplayCards = filterCardsByFeatureSet(customSearchCards, flags)
    return userDisplayCards.map((csc) => ({ ...csc, id: `CC-${uuidv4()}` }))
}
